import { render } from "./FacebookCommentComponent.vue?vue&type=template&id=0dd53715&scoped=true"
import script from "./FacebookCommentComponent.vue?vue&type=script&lang=js"
export * from "./FacebookCommentComponent.vue?vue&type=script&lang=js"

import "./FacebookCommentComponent.vue?vue&type=style&index=0&id=0dd53715&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd53715"]])

export default __exports__